import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Don't throw at import time — Landing page and other static surfaces should
  // still render without a Supabase project wired up. Runtime callers that
  // actually need the client will surface the error themselves.
  console.warn(
    '[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY not set. Copy .env.example → .env.local and fill them in before using auth/DB features.',
  );
}

// supabase-js ≥ 2.x throws synchronously when URL/key are falsy, which would
// crash the app before React mounts. Fall back to a placeholder so the module
// loads cleanly; requests will fail at the network layer and be caught by the
// query/auth layer above.
export const isSupabaseConfigured = !!(url && anonKey);

export const supabase = createClient<Database>(
  url || 'https://placeholder.supabase.co',
  anonKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
